import {Text} from './text';

export class Services {
  id?: number = 0;
  title: Text[] = [];
  mobileTitle?: Text[];
  subtitle?: string[] = [];
  img: string = '';
  filter?: boolean;
  filterNumber?: number;
  vail?: number;
  buttonText?: string;
  feedValue?: Text[];
  firstParagraph?: string[];
  objectPosition?: string;
  backgroundPosition?: string;
  scale?: string;
  backgroundScale?: string;


  constructor(value?: Services) {
    if(value?.id != undefined) this.id = value?.id;
    this.title = value?.title ?? [];
    this.mobileTitle = value?.mobileTitle ?? this.title;
    this.subtitle = value?.subtitle ?? [];
    this.img = value?.img ?? '';
    this.filter = value?.filter;
    this.filterNumber = value?.filterNumber;
    this.vail = value?.vail;
    this.buttonText = value?.buttonText;
    this.feedValue = value?.feedValue;
    this.firstParagraph = value?.firstParagraph;
    this.objectPosition = value?.objectPosition;
    this.backgroundPosition = value?.backgroundPosition;
    this.scale = value?.scale;
    this.backgroundScale = value?.backgroundScale;
  }
}

export const ServicesArray: Services[] = [
  { //1
    id: 0,
    title: [{
      text: ['Персональное сопровождение', 'Personal Assistance'],
    }],
    mobileTitle: [{
      text: ['Ассистент', 'Travel PA'],
    }],
    subtitle: ['Персональный тревел-менеджер — это человек, который сопровождает вас до, во время и после путешествия, беря на себя все ключевые детали — от идеи маршрута до вашего возвращения домой.\n' +
    '\n' +
    'Он помогает с выбором направления, бронированием отелей, вилл и шале, организует перелёты, VIP-сервисы в аэропортах и трансферы, а также занимается бронированием ресторанов, гидов, билетов на различные события и выполнением особых запросов, обеспечивая комфортную и логичную структуру поездки.\n' +
    '\n' +
    'Наши менеджеры свободно владеют двумя–тремя языками, регулярно путешествуют сами и обладают экспертными знаниями по множеству направлений и отелей, глубоко понимая процессы, стандарты сервиса и ожидания гостей.\n' +
    '\n' +
    'Мы остаёмся на связи на протяжении всего путешествия и оперативно решаем возникающие вопросы, позволяя сосредоточиться на самом главном — самом путешествии.', 'A personal travel manager is a professional who supports you before, during, and after your trip, taking care of all key details—from the initial travel concept to your return home.\n' +
    '\n' +
    'They assist with destination selection, booking hotels, villas, and chalets, arranging flights, VIP airport services, and transfers, as well as reserving restaurants, guides, tickets to events, and handling special requests—ensuring a seamless, comfortable, and well-structured journey.\n' +
    '\n' +
    'Our managers are fluent in two to three languages, travel extensively themselves, and possess expert knowledge of numerous destinations and hotels, with a deep understanding of processes, service standards, and guest expectations.\n' +
    '\n' +
    'We stay in touch throughout the entire trip and promptly resolve any issues that arise, allowing you to focus on what truly matters—the journey itself.'],
    img: '/app/assets/images/bg/manager.png',
    filter: true,
    feedValue: [{text: ['Персональный travel-менеджер', 'Personal Travel Manager']},],
    objectPosition: '-120px',
    backgroundPosition: '-880px'
  },
  { //2
    id: 0,
    title: [{
      text: ['Бронирование отелей', 'Hotel Booking'],
    }],
    subtitle: ['Основным направлением нашей деятельности является оказание услуг по бронированию отелей по всему миру. Мы работаем напрямую с ведущими отельными сетями и независимыми пятизвёздочными отелями, что позволяет выстраивать долгосрочные партнёрские отношения и предлагать клиентам высокий уровень сервиса и доверия со стороны отелей.\n' +
    '\n' +
    'Наличие прямых контрактов и выстроенного взаимодействия с гостиничными партнёрами даёт доступ к выгодным условиям бронирования, приоритетному подтверждению, гибким правилам отмены и дополнительным преимуществам — таким как повышение категории номера при наличии, ранний заезд, поздний выезд и персональные комплименты от отеля.\n' +
    '\n' +
    'Многие отели мы инспектируем лично, уделяя внимание не только номерам и инфраструктуре, но и атмосфере, уровню сервиса и деталям, которые невозможно оценить по фотографиям. При рекомендации и выборе отелей мы также опираемся на ведущие международные рейтинги и профессиональные гиды, среди которых The World’s 50 Best Hotels, Condé Nast Traveler Gold List, Forbes Travel Guide.\n' +
    '\n' +
    'Глубокое понимание стандартов гостиничной индустрии и ожиданий гостей премиального уровня позволяет точно подбирать отели под цели поездки — будь то отдых, деловая поездка, семейное путешествие или особое событие. Каждое бронирование сопровождается персонально, от первого запроса до завершения проживания.\n' +
    '\n' +
    'Такой подход обеспечивает клиентам уверенность, комфорт и доступ к лучшим предложениям рынка.', 'Our core business is providing hotel booking services worldwide. We work directly with leading hotel chains and independent five-star hotels, which allows us to build long-term partnerships and offer our clients a high level of service and trust from the hotels.\n' +
    '\n' +
    'Having direct contracts and well-established relationships with our hotel partners gives us access to preferential booking conditions, priority confirmation, flexible cancellation policies, and additional benefits such as room upgrades subject to availability, early check-in, late check-out, and personalized amenities from the hotel.\n' +
    '\n' +
    'We personally inspect many of the hotels we recommend, paying attention not only to rooms and facilities but also to the atmosphere, service quality, and details that cannot be fully assessed through photographs. When selecting and recommending hotels, we also rely on leading international rankings and professional guides, including The World’s 50 Best Hotels, Condé Nast Traveler Gold List, and Forbes Travel Guide.\n' +
    '\n' +
    'A deep understanding of hospitality industry standards and the expectations of premium-level guests enables us to accurately match hotels to the purpose of each trip—whether leisure, business travel, a family vacation, or a special occasion. Every booking is managed personally, from the initial request to the completion of the stay.\n' +
    '\n' +
    'This approach provides our clients with confidence, comfort, and access to the best offers on the market.'],
    img: '/app/assets/images/bg/hotels.jpg',
    filter: true,
    filterNumber: 60,
    vail: 0.5,
    feedValue: [{text: ['Бронирование отелей', 'Hotel Booking']},],
    backgroundPosition: '-470px'
  },
  { //3
    id: 0,
    title: [{
      text: ['Аренда частных джетов', 'Private Jet Charter'],
    }],
    subtitle: ['Одним из направлений нашей работы является организация чартерных перелётов и аренда частных самолётов по всему миру. Мы помогаем подобрать оптимальный тип воздушного судна с учётом маршрута, количества пассажиров, целей поездки и требуемого уровня комфорта.\n' +
    '\n' +
    'Работа ведётся с проверенными операторами частной авиации и надёжными авиационными брокерами, что позволяет обеспечивать высокий уровень безопасности, прозрачные условия и точное соблюдение графика. Частная авиация даёт свободу в выборе времени вылета, аэропортов отправления и прибытия, а также позволяет значительно сократить время в пути и избежать лишних пересадок.\n' +
    'Аренда самолёта подойдёт как для деловых поездок, так и для частных путешествий, семейных перелётов или сопровождения групп и корпоративных команд. В зависимости от задачи подбираются лёгкие и средние джеты, дальнемагистральные бизнес-джеты или турбовинтовые самолёты.\n' +
    '\n' +
    'Мы берём на себя все организационные вопросы — от подбора борта и согласования маршрута до наземного обслуживания, питания и сопровождения пассажиров. Такой подход позволяет клиентам путешествовать спокойно и уверенно, полностью контролируя формат перелёта и не отвлекаясь на детали.', 'One of our key areas of expertise is the organization of charter flights and private jet rentals worldwide. We assist in selecting the most suitable aircraft based on the route, number of passengers, purpose of the trip, and the required level of comfort.\n' +
    '\n' +
    'We work with trusted private aviation operators and reliable aviation brokers, ensuring a high level of safety, transparent terms, and strict adherence to schedules. Private aviation offers complete flexibility in departure times, as well as in the choice of departure and arrival airports, significantly reducing travel time and eliminating unnecessary connections.\n' +
    '\n' +
    'Aircraft charter is suitable for business trips as well as private travel, family flights, or transportation for groups and corporate teams. Depending on the specific requirements, we arrange light and midsize jets, long-range business jets, or turboprop aircraft.\n' +
    '\n' +
    'We handle all organizational aspects—from aircraft selection and route coordination to ground handling, catering, and passenger support. This comprehensive approach allows our clients to travel with confidence and peace of mind, maintaining full control over the flight experience without being distracted by operational details.'],
    img: '/app/assets/images/bg/jets.jpg',
    filter: true,
    filterNumber: 40,
    vail: 0.5,
    feedValue: [{text: ['Аренда частных джетов', 'Private Jet Charter']},],
    objectPosition: '-16px',
    backgroundPosition: '-385px'
  },
  { //4
    id: 0,
    title: [{
      text: ['VIP-сервисы в аэропортах', 'Airport Vip Services'],
    }],
    subtitle: ['Мы оказываем услуги VIP-сервиса в аэропортах по всему миру, обеспечивая комфортное и максимально быстрое прохождение всех формальностей при вылете, прилёте и транзите.\n' +
    '\n' +
    'В рамках сервиса предоставляются Meet & Greet, Fast Track, персональное сопровождение, доступ в VIP-лаунжи и приватные залы, а также помощь с багажом и навигацией по аэропорту. Все процессы выстраиваются с учётом расписания рейса, статуса пассажира и индивидуальных пожеланий.\n' +
    '\n' +
    'VIP-сервис особенно актуален для деловых поездок, путешествий с детьми, VIP-гостей и корпоративных команд, когда важны конфиденциальность, экономия времени и высокий уровень внимания.\n' +
    '\n' +
    'Мы берём на себя полную координацию услуги, взаимодействие с аэропортовыми службами и сопровождение на всех этапах, обеспечивая спокойный и комфортный опыт независимо от аэропорта и направления.', 'We provide VIP airport services worldwide, ensuring a comfortable and максимально fast passage through all formalities during departure, arrival, and transit.\n' +
    '\n' +
    'The service includes Meet & Greet, Fast Track, personal assistance, access to VIP lounges and private terminals, as well as support with luggage handling and airport navigation. All processes are tailored to the flight schedule, passenger status, and individual preferences.\n' +
    '\n' +
    'VIP airport services are particularly valuable for business travel, journeys with children, VIP guests, and corporate teams, where confidentiality, time efficiency, and a high level of personal attention are essential.\n' +
    '\n' +
    'We take full responsibility for coordinating the service, liaising with airport authorities, and providing support at every stage, ensuring a smooth and comfortable experience regardless of the airport or destination.'],
    img: '/app/assets/images/bg/airportvipservices.jpg',
    filter: true,
    feedValue: [{text: ['VIP-сервисы в аэропортах', 'Airport VIP Services']},],
    objectPosition: '-13px',
    backgroundPosition: '-341px',
    scale: '1.5'
  },
  { //5
    id: 0,
    title: [{
      text: ['Бронирование билетов', 'Flight Tickets'],
    }],
    subtitle: ['Мы оказываем услуги по бронированию авиабилетов для частных и корпоративных клиентов по всему миру. Подбор маршрутов и тарифов осуществляется с учётом целей поездки, сроков, бюджета и предпочтений пассажиров.\n' +
    '\n' +
    'В работе используются как регулярные рейсы ведущих авиакомпаний, так и специальные корпоративные и агентские тарифы, что позволяет предлагать оптимальные варианты перелётов, удобные стыковки и гибкие условия изменения или возврата билетов.\n' +
    '\n' +
    'Мы обеспечиваем полное сопровождение бронирования — от оформления билетов до онлайн-регистрации на рейсы, выбора мест и внесения изменений при необходимости. Клиенту не требуется самостоятельно взаимодействовать с авиакомпаниями или сервисами.\n' +
    '\n' +
    'Для корпоративных клиентов процесс выстраивается с учётом требований к документообороту и внутренних регламентов компании. Все операции осуществляются прозрачно, с предоставлением необходимых документов.\n' +
    '\n' +
    'Каждое бронирование сопровождается персонально на всех этапах поездки, обеспечивая надёжность, экономию времени и комфорт в путешествии.', 'We provide flight ticket booking services for private and corporate clients worldwide. Routes and fares are selected based on the purpose of the trip, travel dates, budget, and passenger preferences.\n' +
    '\n' +
    'We work with both scheduled flights operated by leading airlines and special corporate and agency fares, allowing us to offer optimal flight options, convenient connections, and flexible conditions for ticket changes or refunds.\n' +
    '\n' +
    'We provide full booking support—from ticket issuance to online check-in, seat selection, and making changes when required. Clients do not need to interact directly with airlines or booking platforms.\n' +
    '\n' +
    'For corporate clients, the process is structured in accordance with company policies and documentation requirements. All transactions are handled transparently, with the provision of all necessary documents.\n' +
    '\n' +
    'Each booking is managed personally at every stage of the journey, ensuring reliability, time efficiency, and comfort while traveling.'],
    img: '/app/assets/images/bg/Flighttickets.jpg',
    // filter: true,
    feedValue: [{text: ['Авиабилеты', 'Flight Tickets']},],
    objectPosition: '-5px -8px',
    backgroundPosition: '-100px',
    scale: '1.5'
  },
  { //6
    id: 0,
    title: [{
      text: ['Визовая поддержка', 'Visa Services'],
    }],
    subtitle: ['Мы оказываем услуги по визовому сопровождению для частных и корпоративных клиентов, помогая оформить визы в различные страны с учётом цели поездки, сроков и требований конкретного консульства.\n' +
    '\n' +
    'В рамках визовой поддержки осуществляется консультация по типам виз, проверка и подготовка документов, заполнение анкет, запись на подачу и сопровождение процесса до получения решения. Мы внимательно отслеживаем изменения визовых правил и требований, что позволяет минимизировать риски задержек и отказов.\n' +
    '\n' +
    'Наш подход позволяет сэкономить время и избежать лишних сложностей, обеспечивая понятный, организованный и надёжный процесс оформления виз — независимо от направления и формата поездки.', 'We provide visa support services for private and corporate clients, assisting with the arrangement of visas to various countries in accordance with the purpose of travel, timelines, and the requirements of the relevant consulate.\n' +
    '\n' +
    'Our visa support includes consultations on visa types, document review and preparation, completion of application forms, appointment scheduling, and process supervision until a decision is issued. We closely monitor changes in visa regulations and requirements, allowing us to minimize the risk of delays or refusals.\n' +
    '\n' +
    'Our approach saves time and helps avoid unnecessary complications, ensuring a clear, well-organized, and reliable visa application process—regardless of destination or travel format.'],
    img: '/app/assets/images/bg/VisaServices.jpg',
    filter: true,
    filterNumber: 40,
    feedValue: [{text: ['Визовая поддержка', 'Visa Support']},],
    objectPosition: '-70px -25px',
    backgroundPosition: '-490px',
    scale: '2.5',
    backgroundScale: '1.5'
  },
  { //7
    id: 0,
    title: [{
      text: ['Аренда шале', 'Chalet Rental'],
    }],
    subtitle: ['Мы оказываем услуги по аренде шале в популярных горнолыжных регионах мира, помогая подобрать оптимальный вариант с учётом состава гостей, предпочтений и формата отдыха.\n' +
    '\n' +
    'В нашем доступе как частные шале, так и объекты премиум-класса с сервисом уровня пятизвёздочного отеля — с персоналом, шеф-поваром, консьержем, спа-зонами и прямым доступом к склонам. Такой формат идеально подходит для семей, компаний друзей и корпоративных поездок.\n' +
    '\n' +
    'Подбор шале осуществляется индивидуально — по количеству спален, расположению, уровню приватности и инфраструктуре. Мы внимательно учитываем детали, которые влияют на комфорт проживания: от планировки и видов до уровня сервиса и логистики.\n' +
    '\n' +
    'Мы сопровождаем аренду на всех этапах — от подбора и бронирования до координации заезда и дополнительных услуг на месте. Это позволяет клиентам сосредоточиться на отдыхе и наслаждаться поездкой без организационных вопросов.', 'We offer chalet rental services in popular ski regions worldwide, helping clients select the optimal option based on the number of guests, preferences, and the desired style of vacation.\n' +
    '\n' +
    'Our portfolio includes both private chalets and premium properties with five-star hotel-level services—staff, private chefs, concierge, spa facilities, and direct access to the slopes. This format is ideal for families, groups of friends, and corporate trips.\n' +
    '\n' +
    'Chalet selection is personalized, taking into account the number of bedrooms, location, level of privacy, and available amenities. We pay close attention to details that affect comfort, from layout and views to service standards and logistics.\n' +
    '\n' +
    'We provide full support throughout the rental process—from selection and booking to coordinating check-in and additional on-site services. This allows clients to focus on enjoying their vacation without worrying about organizational details.'],
    img: '/app/assets/images/bg/CHALLETS.jpg',
    // filter: true,
    feedValue: [{text: ['Аренда шале', 'Chalet Rental']},],
    backgroundPosition: '-190px',
  },
  { //8
    id: 0,
    title: [{
      text: ['Аренда яхт', 'Superyacht Charters'],
    }],
    subtitle: [
      'Мы с радостью подберем для вас подходящую яхту в аренду с учётом маршрута, формата путешествия и индивидуальных пожеланий. Чартер суперяхты — это один из самых свободных и приватных форматов путешествий, в котором нет жёстких маршрутов и ограничений. Каждый день может начинаться в новом месте, а планы — меняться по ходу пути, подстраиваясь под настроение и желания гостей.\n' +
      '\n' +
      'Романтический круиз, семейный отдых, путешествие с друзьями или празднование значимого события — формат поездки полностью остаётся за вами. Подбор суперяхт осуществляется совместно с проверенными партнёрами, являющимися членами MYBA (Mediterranean Yacht Brokers Association), что гарантирует высокий уровень профессионализма, прозрачные условия и соответствие международным стандартам чартерного рынка.\n' +
      '\n' +
      'Современные суперяхты по уровню комфорта и сервиса уверенно конкурируют с лучшими пятизвёздочными отелями мира. Просторные каюты, продуманные интерьеры, отделочные материалы премиального качества, спа-зоны, бассейны, тренажёрные залы, кинотеатры и оборудование для водных видов спорта создают пространство для полноценного отдыха без компромиссов.', 'We are happy to help you select the perfect yacht for charter, taking into account your itinerary, travel style, and personal preferences. Chartering a superyacht offers one of the most flexible and private ways to travel, with no fixed routes or restrictions. Each day can start in a new location, and plans can change along the way to match the mood and desires of the guests.\n' +
      '\n' +
      'Whether it’s a romantic cruise, a family vacation, a trip with friends, or celebrating a special occasion, the format of the journey is entirely up to you. Superyacht selection is done in collaboration with trusted partners who are members of MYBA (Mediterranean Yacht Brokers Association), ensuring high professionalism, transparent terms, and compliance with international charter standards.\n' +
      '\n' +
      'Modern superyachts offer comfort and service levels that rival the best five-star hotels in the world. Spacious cabins, thoughtfully designed interiors, premium-quality finishes, spa areas, swimming pools, gyms, cinemas, and water sports equipment create an environment for a fully enjoyable, uncompromised vacation.'],
    img: '/app/assets/images/bg/yachts.jpg',
    vail: 0.5,
    objectPosition: '-97px',
    filter: true,
    filterNumber: 10,
    feedValue: [{text: ['Аренда яхт', 'Yacht Charter']},]
  },
  { //9
    id: 0,
    title: [{
      text: ['Круизы', 'Cruises'],
    }],
    subtitle: ['Наша компания занимается организацией круизных путешествий и помогает подобрать оптимальный маршрут и формат круиза с учётом ваших предпочтений, сроков и стиля отдыха. Круиз — это комфортный и продуманный способ увидеть несколько стран и городов за одну поездку, не меняя отели и не тратя время на переезды.\n' +
    '\n' +
    'Морские и речные круизы подойдут как для спокойного отдыха, так и для насыщенного путешествия с новыми впечатлениями каждый день. Это может быть романтическое путешествие, семейный отпуск, поездка с друзьями или особое событие, которое хочется отметить в необычном формате. Маршрут, продолжительность и класс лайнера подбираются индивидуально, чтобы поездка полностью соответствовала ожиданиям.\n' +
    '\n' +
    'Современные круизные лайнеры предлагают уровень комфорта, сопоставимый с лучшими пятизвёздочными отелями: просторные каюты, рестораны высокой кухни, спа-центры, бассейны, фитнес-залы, театры и разнообразные развлечения на борту. При этом каждый день открываются новые направления, города и пейзажи — без спешки и суеты.\n' +
    '\n' +
    'Мы берём на себя подбор круиза, бронирование кают, организацию сопутствующих услуг и сопровождение на всех этапах поездки. Такой подход позволяет путешествовать спокойно и уверенно, наслаждаясь маршрутом, сервисом и впечатлениями, не отвлекаясь на организационные детали.', 'Our company specializes in organizing cruise journeys and helps select the optimal route and type of cruise based on your preferences, schedule, and style of travel. A cruise offers a comfortable and well-planned way to visit multiple countries and cities in a single trip without changing hotels or spending time on transfers.\n' +
    '\n' +
    'Both ocean and river cruises are suitable for a relaxing vacation or an action-packed journey with new experiences each day. Whether it’s a romantic getaway, a family holiday, a trip with friends, or a special occasion to celebrate in a unique way, the itinerary, duration, and class of the ship are tailored individually to fully meet your expectations.\n' +
    '\n' +
    'Modern cruise ships provide comfort levels comparable to the best five-star hotels: spacious cabins, fine dining restaurants, spa centers, swimming pools, fitness facilities, theaters, and a wide range of onboard entertainment. At the same time, each day brings new destinations, cities, and landscapes—without rush or stress.\n' +
    '\n' +
    'We take care of selecting the cruise, booking cabins, arranging additional services, and providing support at every stage of the journey. This approach allows you to travel with peace of mind, fully enjoying the route, service, and experiences without worrying about organizational details.'],
    img: '/app/assets/images/bg/CRUISES.jpg',
    filter: true,
    filterNumber: 25,
    feedValue: [{text: ['Круизы', 'Cruises']},],
    backgroundPosition: '-590px',
  },
  { //10
    id: 0,
    title: [{
      text: ['Корпоративным клиентам', 'Corporate Client'],
    }],
    subtitle: ['Мы оказываем комплексные туристические услуги для корпоративных клиентов и юридических лиц по всему миру. Компания сопровождает деловые поездки, корпоративные выезды и международные проекты, обеспечивая удобную логистику, чёткую координацию и высокий уровень сервиса.\n' +
    '\n' +
    'В рамках корпоративного туризма организуются командировки, размещение в отелях, трансферы, перелёты, визовая и сопутствующая поддержка, а также сопровождение групп и офисов во время поездок. Все решения подбираются с учётом внутренних регламентов компании, сроков, бюджета и целей поездки.\n' +
    '\n' +
    'Работа ведётся на основании договора с предоставлением полного комплекта необходимых документов, включая договоры, инвойсы, акты выполненных работ и закрывающие документы. Это обеспечивает прозрачность, удобство бухгалтерского учёта и соответствие корпоративным и юридическим требованиям.\n' +
    '\n' +
    'Мы сотрудничаем с проверенными международными партнёрами — от отельных сетей и авиаперевозчиков до локальных поставщиков услуг в разных странах, что позволяет обеспечивать стабильное качество сервиса и надёжность на всех этапах путешествия.\n' +
    '\n' +
    'Полная координация туристических процессов, финансовых и организационных вопросов позволяет корпоративным клиентам сосредоточиться на бизнес-задачах, не отвлекаясь на детали поездки.', 'We provide comprehensive travel services for corporate clients and legal entities worldwide. Our company manages business trips, corporate travel, and international projects, ensuring smooth logistics, precise coordination, and a high level of service.\n' +
    '\n' +
    'Within corporate travel, we organize business trips, hotel accommodations, transfers, flights, visa and related support, as well as group and office assistance during trips. All solutions are tailored to company policies, timelines, budgets, and travel objectives.\n' +
    '\n' +
    'Services are provided under formal agreements, with a full set of necessary documentation, including contracts, invoices, work completion certificates, and closing documents. This ensures transparency, ease of accounting, and compliance with corporate and legal requirements.\n' +
    '\n' +
    'We collaborate with trusted international partners—from hotel chains and airlines to local service providers in various countries—ensuring consistent service quality and reliability at every stage of the journey.\n' +
    '\n' +
    'Full coordination of travel processes, financial matters, and organizational issues allows corporate clients to focus on business objectives without being distracted by the details of the trip.'],
    img: '/app/assets/images/bg/man.jpg',
    filter: true,
    feedValue: [{text: ['Корпоративным клиентам', 'Corporate Services']},],
    backgroundPosition: '-450px',
  },
];

export const AboutArray: Services[] = [
  { //1
    id: 0,
    title: [{
      text: ['О компании First Class Solutions Limited', 'About the Company'],
    }],
    subtitle: ['международная компания, зарегистрированная в Гонконге и аккредитованная в системе IATA TIDS, ' +
    'специализирующаяся на организации индивидуальных путешествий и премиального сервиса для частных и корпоративных ' +
    'клиентов по всему миру.',
      'First Class Solutions Limited is an international company registered in Hong Kong and accredited in the IATA TIDS' +
      ' system, specializing in the organization of tailor-made travel and premium services for private and corporate ' +
      'clients worldwide.'
    ],
    img: '/app/assets/images/about/cars.jpg',
  },
  { //1
    id: 1,
    title: [{
      text: ['Наши партнёры', 'Our Partners'],
    }],
    subtitle: [
      'стиничными брендами, авиакомпаниями, аэропортами и ключевыми партнёрами индустрии luxury travel, обеспечивая ' +
      'нашим клиентам привилегированные условия размещения, дополнительные преимущества и персонализированный ' +
      'уровень сервиса.',
      'We collaborate with leading global hotel brands, airlines, airports, and key partners in the luxury travel ' +
      'industry, providing our clients with privileged accommodation conditions, additional benefits, and a ' +
      'personalized level of service.'
    ],
    img: '/app/assets/images/about/hotel.png',
  },
  { //1
    id: 2,
    title: [{
      text: ['Персональный сервис', 'Personal Service'],
    }],
    subtitle: ['Мы сопровождаем как частных клиентов, так и корпоративных партнёров, обеспечивая полный цикл ' +
    'организации поездки — от планирования маршрута и бронирования авиабилетов до поддержки и координации ' +
    'во время путешествия.',
      'We support both private clients and corporate partners, providing a full cycle of travel organization — ' +
      'from itinerary planning and flight bookings to assistance and coordination throughout the journey.'
    ],
    img: '/app/assets/images/about/mountain.jpg',
  },
];

export const ServicesArrayOld: Services[] = [
  {
    id: 0,
    title: [{
      text: ['Аренда яхт', 'Yacht Rental'],
    }],
    subtitle: ['Погрузитесь в атмосферу роскоши и комфорта с нашей услугой аренды яхт. Современный флот стильных и просторных судов, оснащённых всем необходимым, а опытные экипажи готовы воплотить в жизнь любые ваши пожелания. Откройте для себя исключительное путешествие по воде — комфортно, элегантно и незабываемо',
      'Experience an exceptional journey on the water with our luxury yacht rental service. Our fleet features modern and comfortable vessels, fully staffed with professional crews ready to cater to your every need'
    ],
    img: '/app/assets/images/bg/yachts.jpg',
    vail: 0.5,
  },
  {
    id: 0,
    title: [{
      text: ['Круизы', 'CRUISES'],
    }],
    subtitle: ['Погрузитесь в чарующее морское путешествие, где каждый миг наполнен роскошью и безграничным комфортом. Откройте для себя новые горизонты, исследуйте живописные уголки мира и создайте незабываемые воспоминания',
      'Embark on unique sea voyages that open up new horizons and unforgettable experiences, where every moment is filled with luxury and comfort. Our cruises offer diverse itineraries and exploration opportunities, promising unforgettable adventures on the water'
    ],
    img: '/app/assets/images/bg/CRUISES.jpg',
    filter: true,
  },
  {
    id: 0,
    title: [{
      text: ['Шале', 'CHALLETS'],
    }],
    subtitle: ['Откройте для себя истинную гармонию в роскошных шале с безупречным сервисом и изысканными удобствами, расположенных в живописных горах. Погрузитесь в атмосферу полного спокойствия и восхищайтесь захватывающими панорамами',
      'Feel true harmony in luxurious chalets with top-class service and exquisite amenities, located in the heart of the mountains. Indulge in serenity and breathtaking mountain views, creating unforgettable moments in our meticulously chalets designed for ultimate relaxation and rejuvenation'
    ],
    img: '/app/assets/images/bg/CHALLETS.jpg',
    filter: true,
    filterNumber: 30,
  },
  {
    id: 0,
    title: [{
      text: ['Отели', 'hotels'],
    }],
    subtitle: ['Насладитесь комфортом и разнообразием услуг в отелях, которые предлагают сочетание роскошных номеров и широких возможностей для отдыха и развлечений',
      'Enjoy ultimate relaxation and adventure at our hotels, offering a blend of luxury accommodations and extensive amenities'
    ],
    img: '/app/assets/images/bg/hotels.jpg',
    filter: true,
    filterNumber: 60,
    vail: 0.5,
  },
  {
    id: 0,
    title: [{
      text: ['Виллы', 'villas'],
    }],
    subtitle: ['Откройте для себя оазисы роскоши — виллы, которые предлагают непревзойденную приватность и захватывающие виды, создавая идеальное пространство для отдыха и уединения',
      'Discover oases of luxury in our villas. Enjoy unparalleled privacy and magnificent views unfolding right from your cozy corner of paradise'
    ],
    img: '/app/assets/images/bg/villas.jpg',
    filter: true,
  },
  {
    id: 0,
    title: [{
      text: ['Джеты', 'jets'],
    }],
    subtitle: ['Поднимите свои путешествия на новую высоту с арендой бизнес-джетов — эксклюзивный комфорт, абсолютная приватность и максимальная оперативность для ваших деловых и личных поездок',
      'Elevate your travel with our executive jet rentals, providing unparalleled comfort and efficiency for your business or leisure trips'
    ],
    img: '/app/assets/images/bg/jets.jpg',
    filter: true,
    filterNumber: 60,
    vail: 0.5,
  },
  {
    id: 0,
    title: [{
      text: ['Корпоративным клиентам', 'Corporate client'],
    }],
    subtitle: ['Оптимизируйте бизнес-процессы с нашими специализированными решениями для корпоративных клиентов. Мы знаем, как важно оперативно и эффективно организовать командировки и мероприятия, поэтому предлагаем персональный подход и полный спектр услуг для вашего комфорта и успеха',
      'Elevate your business experience with our tailored services for corporate clients. We understand the unique needs of enterprises and offer bespoke solutions that ensure seamless travel and exceptional support for your corporate events and engagements'],
    img: '/app/assets/images/bg/man.jpg',
    filter: true,
  },
  {
    id: 0,
    title: [{
      text: ['Оформление виз', 'Visa Support'],
    }],
    subtitle: ['Полный комплекс услуг по оформлению визы — от поддержки заявки до ускоренного оформления. Быстро, удобно и без лишних хлопот',
      'Streamline your travel with our comprehensive Visa Services. From application support to expedited processing, we ensure a hassle-free experience, guiding you through every step of the process so you can focus on your journey ahead'
    ],
    img: '/app/assets/images/bg/VisaServices.jpg',
    filter: true,
    filterNumber: 60,
  },
  {
    id: 0,
    title: [{
      text: ['Авиабилеты', 'Flight tickets'],
    }],
    subtitle: ['Подбор и бронирование авиабилетов с учётом ваших предпочтений и расписания. Комфорт и удобство на каждом этапе',
      'Embark on your next adventure with ease through our premium flight ticket services. We provide a curated selection of airline options, ensuring you travel in comfort and style. Our dedicated team is here to assist you in finding the best flights to suit your schedule and preferences'
    ],
    img: '/app/assets/images/bg/Flighttickets.jpg',
    filter: true,
  },
  {
    id: 0,
    title: [{
      text: ['VIP-услуги в аэропорту', 'airport vip services'],
    }],
    subtitle: ['Ускоренная регистрация, доступ в частные залы и персональная поддержка. Комфорт и эксклюзивный сервис на каждом этапе вашего путешествия',
      'Enhance your airport experience with our VIP services, offering expedited check-in, private lounges, and personalized assistance. Enjoy seamless security clearance and exclusive amenities that make your journey as smooth and luxurious as possible'
    ],
    img: '/app/assets/images/bg/airportvipservices.jpg',
    filter: true,
  },
  {
    id: 0,
    title: [{
      text: ['Уникальные впечатления', 'unique experiences'],
    }],
    subtitle: ['Откройте для себя незабываемые моменты — погружение в местную культуру, захватывающие приключения и скрытые жемчужины. Эксклюзивные путешествия, созданные, чтобы вывести вас за пределы обыденного',
      'Uncover unforgettable moments crafted to immerse you in local culture, thrilling adventures, and hidden gems. From exclusive culinary journeys to off-the-beaten-path excursions, each experience is tailored to take you beyond the ordinary and into the extraordinary'],
    img: '/app/assets/images/bg/uniqueexperiences.jpg',
  },
];
